import React from 'react'
import { Container } from 'react-bootstrap';
import './comingsoon.css';

function Rekomendasi() {
  return (
    <Container className='PageNotFound'>
        <h1>Page Not Found</h1>
        <h1>404</h1>
    </Container>
  )
}

export default Rekomendasi